import getData from './axios';
export default {
  // 获取字典信息
  getDict: function getDict() {
    return getData({
      url: '/platform/component/dict/systemId/LC_PLATFORM',
      // 系统参数  各系统可设置固定值
      method: 'GET',
      data: ''
    });
  },
  getMenuInfo: function getMenuInfo(param) {
    return getData({
      url: '/platform/home/user',
      method: 'GET',
      data: param
    });
  },
  getMenuInfoByRole: function getMenuInfoByRole(param) {
    return getData({
      url: '/platform/home/resource',
      method: 'GET',
      data: param
    });
  },
  getRequest: function getRequest(param) {
    return getData({
      method: 'GET',
      url: param.url,
      data: param.data,
      responseType: param.responseType
    });
  },
  postRequest: function postRequest(param) {
    return getData({
      method: 'POST',
      url: param.url,
      data: param.data,
      responseType: param.responseType
    });
  },
  delRequest: function delRequest(param) {
    return getData({
      method: 'DELETE',
      url: param.url,
      data: param.data
    });
  },
  putRequest: function putRequest(param) {
    return getData({
      method: 'PUT',
      url: param.url,
      data: param.data
    });
  }
};